import api from '@/api/'
import { reColumns } from '@/views/groupWeb/business/index'

export const title = {
  Add: '添加链接',
  Edit: '编辑链接'
}

export const strategyCommand = {
  edit(data) {
    this.title = title.Edit
    this.visible = true
    this.isEdit = true
    this.form = JSON.parse(JSON.stringify(data))
  },
  delete(data) {
    const _this = this
    this.$confirm({
      content: '确定要删除吗？',
      okText: '确定',
      cancelText: '取消',
      async onOk() {
        const res = await api.deletePreview({ id: data.id })
        if (res.code === '000000') {
          _this.$message.success('删除成功~')
          _this.getList()
        }
      }
    })
  }
}
